import { DotsCheckbox } from "dots-ui/dotsCheckbox";
import { FormikProps } from "formik";
import { useContext } from "react";
import {
  EventReportWithDataFileRow,
  EventReportWithDataFilesInfo,
  SubmitEventReportWithDataFiles,
} from "../../../../../generated/data-contracts";
import { api } from "../../../../../utils";
import Nbsp from "../../../../../utils/nbsp";
import {
  AvisEditableList,
  IAvisEditableListFieldConfig,
  IRowState,
} from "../../../../shared/components/editableList";
import {
  AvisDescriptiveText,
  AvisFileDownload,
  AvisFileUpload,
  AvisSection,
} from "../../../../shared/components/form";
import { AvisContext } from "../../../../shared/context/AvisContext";

interface IReportWithDataFilesFormProps {
  bag: FormikProps<SubmitEventReportWithDataFiles>;
  bagField: keyof SubmitEventReportWithDataFiles;
  licenseReport: EventReportWithDataFilesInfo | undefined;
  disabled: boolean;
  loading: boolean;
  allowBlankReport: boolean | undefined;
  allowedFileFormats: string[] | undefined;
}
export function ReportWithDataFilesForm(
  props: Readonly<IReportWithDataFilesFormProps>,
) {
  const {
    bag,
    bagField,
    licenseReport,
    allowBlankReport,
    allowedFileFormats,
    disabled,
    loading,
  } = props;
  const { res } = useContext(AvisContext);
  const fieldCollection: IAvisEditableListFieldConfig<
    IRowState<EventReportWithDataFileRow>
  >[] = [
    {
      name: "fileName",
      minWidth: 200,
      width: "80%",
      transformViewValue: (_fieldValue, rowValue) => {
        if (
          !licenseReport ||
          !rowValue.portal_LicenseDocumentId ||
          rowValue.rowState === "Delete"
        )
          return <div>{rowValue.fileName}</div>;

        return (
          <AvisFileDownload
            callApiOnClick={() =>
              api.licenseesGetLicenseDocument(
                licenseReport.licenseHeaderId,
                rowValue.portal_LicenseDocumentId as number,
                {
                  format: "arraybuffer",
                },
              )
            }
            fileName={rowValue.fileName || ""}
          />
        );
      },
      renderField: (field, prefix, i, val, onChange) => {
        if (val.fileName && !val.base64Data && val.portal_LicenseDocumentId) {
          if (!licenseReport || !val.portal_LicenseDocumentId)
            return <div>{val.fileName}</div>;

          return (
            <AvisFileDownload
              callApiOnClick={() =>
                api.licenseesGetLicenseDocument(
                  licenseReport.licenseHeaderId,
                  val.portal_LicenseDocumentId as number,
                  {
                    format: "arraybuffer",
                  },
                )
              }
              fileName={val.fileName}
            />
          );
        }

        return (
          <AvisFileUpload
            name={`${prefix}.${i}.${field.name}`}
            disabled={disabled}
            onChange={onChange}
            allowedFormats={allowedFileFormats}
          />
        );
      },
    },
    {
      name: "portal_LicenseDocumentId",
      width: "20%",
      forceViewMode: true,
      transformViewValue: () => {
        return <Nbsp />;
      },
    },
  ];

  return (
    <>
      <AvisSection title={res("licensees_LicenseReports_label_SectionData")}>
        <AvisDescriptiveText textKey="portal_LIC_LicenseReportForm4" />
        {allowBlankReport && (
          <DotsCheckbox<SubmitEventReportWithDataFiles>
            bag={bag}
            bagField="eventNotOccuredPortal"
            checkboxLabel={res(
              "licensees_LicenseReports_shared_label_EventNotOccured",
            )}
            disabled={disabled}
          />
        )}
      </AvisSection>
      {!bag.values.eventNotOccuredPortal && (
        <AvisSection
          classNameIn="file-collection"
          title={res("label_UploadFiles")}
          textToDisplayKey="portal_LIC_LicenseReportForm4_Files"
        >
          <AvisEditableList<
            SubmitEventReportWithDataFiles,
            EventReportWithDataFileRow
          >
            bag={bag}
            bagField={bagField}
            initValue={{}}
            hideEdit
            confirmBeforeDelete={(data) => {
              if (JSON.stringify(data) === JSON.stringify({})) return undefined;

              return {
                content: res("message_DeleteRow"),
                mustShow: true,
              };
            }}
            fields={fieldCollection}
            disabled={disabled}
            loading={loading}
            maxRows={5}
            view="table"
          />
        </AvisSection>
      )}
    </>
  );
}
